import React, { useState } from 'react';
import { Section } from '../ui/Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un email con los links de descarga. Son 6 archivos PDF, uno por kit.'
  }, {
    q: '¿En qué formato está?',
    a: 'Todo está en PDF, compatible con cualquier dispositivo (celular, tablet, computadora). Podés imprimirlo si preferís.'
  }, {
    q: '¿Las recetas rinden para cuántas porciones?',
    a: 'La mayoría rinde entre 4 y 6 porciones, ideal para cocinar por tandas y congelar varias raciones.'
  }, {
    q: '¿Necesito equipo especial?',
    a: 'No. Las recetas usan horno, hornalla y olla convencional. Algunas incluyen opción para freidora de aire, pero no es obligatorio.'
  }, {
    q: '¿Esto incluye plan semanal o listas de compra?',
    a: 'No, este pack incluye únicamente los 6 recetarios en PDF (180 recetas total). No incluye planificador semanal, listas de compra ni guías adicionales.'
  }, {
    q: '¿Puedo elegir kits sueltos?',
    a: 'Este pack incluye los 6 kits completos. Por ahora no se venden por separado.'
  }];
  return <Section data-id="element-15">
      <div className="text-center mb-6 md:mb-10" data-id="element-16">
        <h2 className="text-2xl md:text-4xl font-bold text-brand-slate-900 mb-3 md:mb-4" data-id="element-17">
          Preguntas frecuentes
        </h2>
      </div>

      <div className="max-w-2xl mx-auto space-y-2.5 md:space-y-3" data-id="element-18">
        {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-19" />)}
      </div>
    </Section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-brand-slate-200 rounded-xl bg-white overflow-hidden" data-id="element-20">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between gap-3 p-4 md:p-5 text-left font-semibold text-sm md:text-base text-brand-slate-900 hover:bg-brand-slate-50 transition-colors" data-id="element-21">
        <span className="pr-2" data-id="element-22">{question}</span>
        <ChevronDown className={`w-5 h-5 text-brand-slate-400 flex-shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-23" />
      </button>
      <AnimatePresence data-id="element-24">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} data-id="element-25">
            <div className="px-4 pb-4 md:px-5 md:pb-5 text-sm text-brand-slate-600 leading-relaxed" data-id="element-26">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}